import * as React from "react";
import Component from "../../AbstractComponent";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import Constants from "../../../Action/Constants";
import { UnitInterface } from "../../../Entity/Entities/Unit/UnitInterface";
import { AddressSelector } from "../../Partials/AddressSelector/AddressSelector";
import { PropertyInterface } from "../../../Entity/Entities/Property/PropertyInterface";
import * as uuidV4 from "uuid/v4";
import PropertyLookup from "../../Partials/Lookup/PropertyLookup";
import { PageTransition } from "../../Partials/Spinner/PageTransition";

import { NewCoachWrapper } from "./NewCoach/NewCoachWrapper";
import { Title } from "./NewCoach/NewCoachComponents/Title";
import { Subtitle } from "./NewCoach/NewCoachComponents/Subtitle";
import { CoachSummaryTable } from "./NewCoach/NewCoachContents/CoachSummaryTable";

export class CoachMoveUnitDialog extends Component {
  public state = {
    activeStep: 0,
    skipped: new Set(),
    openCoachMoveUnit: false,
    hasModifiedData: false,
    openLeavePrompt: false,
    disableButtonDuringRequest: false,
    errorFields: null,
    selectedProperty: null,
    isFinishDialogOpen: false,
    address: {
      formattedAddress: ""
    },
    propertyChoise: "existingproperty",
    isSaving: false
  };

  constructor(public props) {
    super(props);
  }

  public componentWillMount() {
    // Filter properties by the unit property and if there is only one, set it to state.
    // If there is no filtered properties, select new property radio.
    const filteredProperties = this.props.unit?.property?.company?.properties?.filter((property) => property.id !== this.props.unit?.property?.id)
    this.setState({
      openCoachMoveUnit: this.props.openCoachMoveUnit,
      selectedProperty: filteredProperties.length === 1 ? filteredProperties[0] : null,
      propertyChoise: filteredProperties.length === 0 ? "newproperty" : "existingproperty",
    });
	}

  public clearState = () => {
    this.setState({
      activeStep: 0,
      skipped: new Set(),
      openCoachMoveUnit: false,
      hasModifiedData: false,
      openLeavePrompt: false,
      disableButtonDuringRequest: false,
      errorFields: null,
      selectedProperty: null,
      isFinishDialogOpen: false
    });
  }

  public onCloseCoach = () => {
    this.props.onCloseCoach.call(this);

    setTimeout(() => {this.clearState()}, 100);
    this.clearBackEndErrors();
  }


  /* Main logic for STEPPER */
  // Logic for stepper, use methods when we click button continue on step page, and we start logic.
  public handleNext = () => {
    const { activeStep } = this.state;
    const steps = this.getSteps();

    if(activeStep === steps.length - 1) { // it is last step
      if(this.state.errorFields?.length > 0){
        this.setState({
          isFinishDialogOpen: true
        });
      } else {
        this.onCloseCoach();
      }
    } else {
      switch (activeStep) {
        case 0:
          return this.startStep1();
        case 1:
          return this.startStep2();
        case 2:
          return this.plusOneStep();
      }
    }
  };

  public handleBack = () => {
    const { activeStep } = this.state;

    if(activeStep === 0) {
      if(typeof this.props.openFirstStep !== "undefined"){
        this.clearFieldsError();
        this.clearBackEndErrors();
        this.clearState();
        return this.props.openFirstStep.call(this);
      }
    } else {
      this.clearFieldsError();
      return this.setState({
        activeStep: activeStep - 1,
      });
    }
  }

  public plusOneStep = () => {
    const { activeStep } = this.state;
    this.setState({
      activeStep: activeStep + 1,
    });
  }

  // Here we save all steps name and get count of steps for showing user steps name.
  public getSteps = () => {
    return [
      this.trans("coach/moveunit-step/first-title"),
      this.trans("summary"),
      this.trans("menuitem-finish")
    ];
  }

  //All components with content for steps we have here
  public getStepContent = (step) => {
    switch (step) {
      case 0:
        return this.stepContent(step);
      case 1:
        return this.stepContent(step);
      case 2:
        return this.stepContent(step);
      default:
        return this.trans("unknown-step");
    }
  }

  // Content details for diffenrent steps.
  public stepContent = (step) => {
    return (
      <div>
        {step === 0 && this.firstStepDetails()}
        {step === 1 && this.secondStepDetails()}
        {step === 2 && this.thirdStepDetails()}
      </div>
    )
  }

  // Steppers components content
  public firstStepDetails = () => {
    return (
      <div className="coach-content-wrapper">
        <Title
          title={this.trans("property-address")}
        />
        <Subtitle
          subtitle={this.props.unit?.shortDisplayName || this.props.unit?.displayName}
        />
        <RadioGroup
          name="chargeOwnerChoice"
          className="filters-container"
          value={this.state.propertyChoise}
          onChange={this.changePropertyChoise}
        >
          <FormControlLabel
            control={<Radio color="primary" />}
            value="newproperty"
            label={this.trans("coach/newunit-step/second-newproperty/label")}
            style={{width: "auto", fontSize: "16px"}}
          />           
          <FormControlLabel
            control={<Radio color="primary" />}
            value="existingproperty"
            label={this.trans("coach/newunit-step/second-selectexistingproperty/label")}
            style={{width: "auto", fontSize: "16px"}}
          />
        </RadioGroup>
        {this.state.propertyChoise === "newproperty" ?
        <div style={{minWidth: "450px"}}>
          <AddressSelector
            {...this.props}
            autoFocus={true}
            name="address.googlePlaceId"
            className="scroll-to-address long-label-container"
            searchText={this.state.address.formattedAddress ? this.state.address.formattedAddress : null}
            selectedAddress={this.state.address}
            onSelect={this.sync.bind(this, this.syncronizers.VALUE, "address")}
            onClear={this.sync.bind(this, this.syncronizers.VALUE, "address", {})}
            required={true}
            error={this.getErrorFor("address.googlePlaceId")}
            styleInModal={"pick-object-modal"}
            labelText={this.trans("coach/moveunit-step/select-address")}
          />
        </div>
        :
        <div style={{minWidth: "450px"}}>
          <PropertyLookup
            {...this.props}
            id="propertyId"
            name="propertyId"
            ref="PropertyLookup"
            className="scroll-to-propertyId"
            styleInModal={"styleInModal"}
            isInlineBlock={true}
            width="100%"
            containerWidth="100%"
            floatingLabelText={this.trans("dropdown-searchforproperty-label")}
            autoSelectId={this.state.selectedProperty?.id}
            onSelect={this.selectProperty}
            onClear={this.clearProperty}
            error={!!this.getErrorFor("propertyId") && this.getErrorFor("propertyId")}
            templateFor={"property"}
            onlyPropertyRelatedOwner={this.props.unit?.property?.company}
            filterMainPropertyOnMovingUnit={this.props.unit?.property?.id}
            disableEntityCreation={true}
            hideClickThroughLink={true}
            autoFocus={true}
          />
        </div>  
      }
      </div>
    )
  }

  public secondStepSummary = () => {
    let summaryArr = [
      {
        label: this.trans("old-address"),
        value: this.props.unit?.property?.displayName
      },
      {
        label: this.trans("new-address"),
        value: this.state.propertyChoise === "newproperty" ? this.state.address?.formattedAddress : this.state.selectedProperty?.displayName
      }
    ];

    return summaryArr;
  }

  public secondStepDetails = () => {
    return (
      <div className="coach-content-wrapper">
        <Title
          title={this.trans("coach/moveunit-step/second-title")}
        />
        <Subtitle
          subtitle={this.trans("coach/general-forelast-update-subtitle-dutch-het", {entity: this.trans("label-unit").toLowerCase()})}
        />
        <CoachSummaryTable
          tableRows={this.secondStepSummary()}
        />
      </div>
    )
  }

  public thirdStepDetails = () => {
    return (
      <div className="coach-content-wrapper">
        {this.state.errorFields && this.state.errorFields.length === 0 ?
          <div>
            <Title
              title={this.trans("result")}
            />
            <div style={{display: "flex", justifyContent: "center", marginBottom: "10px"}}>
              {this.image.getAvatar("success", { size: 62 })}
            </div>
            <Subtitle
              subtitle={this.trans("coach/general-summary-update-subtitle-dutch-het", {entity: this.trans("label-unit").toLowerCase()})}
            />
          </div>
          :
          <div>
            <div className="info-text">
              {`${this.trans("coach/moveunit-step/third-errorinfo1")}`}
            </div>
            <div className="error-list-item">
              {
                this.state.errorFields && this.state.errorFields.map( item => {
                  let transField = this.trans(`coach-error-${item}`)

                  return <div className="success-created-entity-or-error">{this.trans("coach/owner-error/field-label", {field: transField})}</div>
                })
              }
            </div>
            <div className="info-text">
              {this.trans("coach/propertyowner-scenario/company-step/fourth-errorinfo2")}
            </div>
          </div>
        }
      </div>
    );
  }

  //Funcionality for steps
  public startStep1 = () => {
    return this.propertyStartStep1();
  }

  public startStep2 = () => {
    return this.propertyStartStep2startStep2();
  }


  //Methods for step logic
  public propertyStartStep1 = () => {
    this.plusOneStep();
  }

  public moveUnit = (propertyId) => {
    this.saving(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_UNIT_UPDATE_START,
        payload: {
          id: this.props.unit?.id,
          unit: {
            propertyId: propertyId
          },
        },
        onSuccess: (_unit: UnitInterface) => {
          this.setState({
            errorFields: [],
            isSaving: false
          });
          this.plusOneStep();
        },
        onError: (err) => {
          this.setState({
            isSaving: false,
            hasModifiedData: true,
            errorFields: err.fields
          });
          this.plusOneStep();
        }
      });
    });
  }

  public propertyStartStep2startStep2 = () => {
    const owner = this.props.unit?.property?.company;

    this.setState({
      isSaving: true
    })

    if (this.state.propertyChoise === "existingproperty") {
      this.moveUnit(this.state.selectedProperty?.id);
    } else {
      this.saving(() => {
        this.props.dispatch({
          type: Constants.PAGE_PROPERTY_CREATE_START,
          payload: {
            property: {
              address: { ...this.state.address },
              companyId: owner?.id,
              // managerId: !this.state.selectedPerson  ? null : this.state.selectedPerson.id,
              amazonFolderName: uuidV4(),
              // note: this.state.note,
              isDefaultUnit: false,
              // chargeTemplatesIds: [...this.state.chargeTemplates].map((chargeTemplate: ChargeTemplateInterface) => chargeTemplate.id),
              // contactInformationOfAssociation: this.state.contactInformationOfAssociation,
              // associationOwnerId: this.state.selectedAssociationOwner ? this.state.selectedAssociationOwner.id : null,
              // complexName: this.state.complexName
            }
          },
          onSuccess: (property: PropertyInterface) => {
            this.moveUnit(property?.id);
          },
          onError: (err) => {
            this.setState({
              isSaving: false,
              hasModifiedData: true,
              errorFields: err.fields
            });
            this.plusOneStep();
          }
        });
      });
    }
  }

  public propertyStartStepThird = () => {
    this.plusOneStep();
  }

  //Methods
  public clearBackEndErrors = () => {
    this.props.dispatch({
      type: Constants.PAGE_CONTACT_COMPANY_CREATE_CLEAR
    })
    this.props.dispatch({
      type: Constants.COACH_ERRORS_CLEAR
    })
  }

  public clearFieldsError = () => {
    this.setState({
      firstNameError: false,
      companyNameError: false
    })
  }

  public changePropertyChoise = (event) => {
    const choice: string = event.target.value;

    this.setState({
      propertyChoise: choice,
      selectedProperty: null,
      address: {
        formattedAddress: ""
      },
    });
  }

  public selectProperty = (property: PropertyInterface): void => {
    this.setState({
      selectedProperty: property,
    });
  }

  public clearProperty = (): void => {
    this.setState({
      selectedProperty: null,
    });
  }

  public render() {
    const steps = this.getSteps();
    return (
      <div>
        <NewCoachWrapper
          state={this.state}
          steps={steps}
          oldCoach={true}
          content={(activeStep) => this.getStepContent(activeStep)}
          openCoach={this.state.openCoachMoveUnit}
          onCloseCoach={this.onCloseCoach}
          onPageChange={(activeStep, isNext) => {
            isNext && this._handlePageChange(activeStep);
            !isNext && this.setState({activeStep, isDisabled: false})
          }}
          showBackButton={this.state.activeStep === 1}
          disabled={false}
          disabledBack={false}
          disabledNext={!this.state.address.formattedAddress && !this.state.selectedProperty}
        />

        <PageTransition isSaving={this.state.isSaving} />
      </div>
    );
  }
}